
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiProdottiBadgeDialog extends Serenity.EntityDialog<UtentiProdottiBadgeRow, any> {
        protected getFormKey() { return UtentiProdottiBadgeForm.formKey; }
        protected getIdProperty() { return UtentiProdottiBadgeRow.idProperty; }
        protected getLocalTextPrefix() { return UtentiProdottiBadgeRow.localTextPrefix; }
        protected getService() { return UtentiProdottiBadgeService.baseUrl; }
        protected getDeletePermission() { return UtentiProdottiBadgeRow.deletePermission; }
        protected getInsertPermission() { return UtentiProdottiBadgeRow.insertPermission; }
        protected getUpdatePermission() { return UtentiProdottiBadgeRow.updatePermission; }

        protected form = new UtentiProdottiBadgeForm(this.idPrefix);

        protected getToolbarButtons() {
            let buttons = super.getToolbarButtons();

            if (Q.Authorization.hasPermission("Role:SuperAdmin")) {
                // Remove All Buttons
                buttons = [];
            }

            return buttons;
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            if (this.idProdotto !== undefined)
                this.form.IdProdottoBadge.cascadeValue = this.idProdotto;

            if (!this.isNewOrDeleted())
                this.form.IdProdottoBadge.value = this.entity.IdProdottoBadge.toString();

            this.dialogTitle = "Badge dell'utente";

            this.set_readOnly(Q.Authorization.hasPermission("Role:SuperAdmin"));
        }

        // ///////////////////////////////////////////////////////////////
        private _idUtenteProdotto: number;

        get idUtenteProdotto() {
            return this._idUtenteProdotto;
        }

        set idUtenteProdotto(value: number) {
            if (this._idUtenteProdotto != value) {
                this._idUtenteProdotto = value;
            }
        }

        // ///////////////////////////////////////////////////////////////
        private _idProdotto: number;

        get idProdotto() {
            return this._idProdotto;
        }

        set idProdotto(value: number) {
            if (this._idProdotto != value) {
                this._idProdotto = value;
            }
        }
    }
}